/* eslint-disable no-unused-vars */
import axios from "axios";
import Vue from "vue";

let state = {
  loading: false,
  me: {}
};

const mutations = {
  setMe(state, me) {
    state.me = { ...me };
  },
  setLoading(state, loading) {
    state.loading = loading;
  }
};

const actions = {
  getMe({ state, commit, getters }, id) {
    return new Promise((resolve, reject) => {
      // Dont load twice
      if (state.me.id) {
        return resolve();
      }

      commit("setLoading", true);
      return axios
        .get(`/api/me`)
        .then(resp => {
          commit("setMe", resp.data.data);
          resolve(resp.data.data);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("setLoading", false);
        });
    });
  }
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
